// generated from 8_074 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const mixpanelCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("mixpanel_cohort_filter"),
  comparison_key: z.enum([
    "7", // 5_363 (66.42%)
    "8", // 2_711 (33.58%)
  ]),
  display_name: z.string(),
  // undefined: 1_273 (15.77%), defined 6_801 (84.23%)
  // format integer: 6_801 (100.00%)
  raw_value: z.string().optional(),
  value: z.object({
    // format integer: 8_071 (99.96%)
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
